import React, { ComponentProps } from 'react';
import { asView } from '../../../../_lib/ViewFetcher';

import { AccessLevelData, DeclinedAccessLevelRequest } from '../../common/types';
import { AccessLevelInformation } from '../../common/partials/AccessLevelInformation';
import { AnyParameter, SonForm } from '../../../../_lib/Form2/types/SonForm';
import {
  ChangeAccessLevelAcceptDeclineForm,
  ChangeAccessLevelDeclineFormTypes,
} from '../partials/ChangeAccessLevelAcceptDeclineForm';
import { useInvalidateRefreshableBlock, useRefreshBlock } from '../../../../_lib/BlockFetcher';
import { BlockType } from '../../../../types/api/ElementType';
import { SendEmailFormTypes } from '../partials/SendEmailForm';

export type EmailStatus = {
  emailState: 'automatically' | 'byAdmin' | 'notSend';
  emailSentDate?: string;
};

export type ChangeAccessLevelDefaultProps = {
  pendingRequest?: AccessLevelData;
  declinedRequest?: DeclinedAccessLevelRequest;
  approveRequestForm?: SonForm<AnyParameter>;
  declineRequestForm?: SonForm<ChangeAccessLevelDeclineFormTypes>;
  removeDeclinedRequest?: SonForm<AnyParameter>;
  removePendingRequest?: SonForm<AnyParameter>;
  sendEmailForm?: SonForm<SendEmailFormTypes>;
  emailStatus?: EmailStatus;
};

function ChangeAccessLevelDefault(props: ChangeAccessLevelDefaultProps) {
  const invalidateRefreshableBlock = useInvalidateRefreshableBlock();
  const { refresh } = useRefreshBlock();

  const refreshAndInvalidate = () => {
    refresh();
    invalidateRefreshableBlock(BlockType.currentAccessLevel);
  };

  return (
    <>
      {props.pendingRequest ? <AccessLevelInformation accessLevelDetails={props.pendingRequest} /> : null}
      {props.approveRequestForm && props.declineRequestForm && (
        <ChangeAccessLevelAcceptDeclineForm
          approveForm={props.approveRequestForm}
          declineForm={props.declineRequestForm}
          refresh={refreshAndInvalidate}
        />
      )}
    </>
  );
}

export const ChangeAccessLevelDefaultView = asView(ChangeAccessLevelDefault);
export type ChangeAccessLevelDefaultView = ComponentProps<typeof ChangeAccessLevelDefaultView>;
